/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import config from 'linced-app/config/environment';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { filterBy, mapBy } from '@linc-technologies/linced-common/utils/arrays';
import { loadPeople } from '@linc-technologies/linced-common/utils/load-people';

export default class FinanceRoute extends Route {
  // Services
  @service
  fetch;

  @service
  options;

  @service
  store;

  model() {
    let person = this.modelFor('people.person').person;

    // Ensure any/all siblings are loaded, so that we can include accounts for only those who aren't archived.
    return loadPeople(this.store, person.get('learner.localSiblingIds') ?? [], {
      includeFormer: true,
    }).then(() => {
      let personIds = [person.id];
      person.get('learner.allSiblings').forEach((sibling) => {
        personIds.push(sibling.personId);
      });

      // Now that we have a list of non-archived siblings, fetch/return the actual data.
      return hash({
        person,
        personIds,
        accounts: this.store
          .query('finance/account', { personIds: JSON.stringify(personIds) })
          .then((accounts) => {
            let learnerAccount = accounts.find(
              (account) => account.person_id === person.id,
            );
            if (isEmpty(learnerAccount)) {
              // This learner does not have a Finance account.  Create one.
              // NOTE: This is done as a direct fetch request to avoid the need to have caregivers' person
              // records loaded at this point, as ember-data requires entities for the hasMany relationship
              // (and will error if only given IDs).
              let url = `${config.APP.apiHost}/finance/${config.APP.apiPath}/accounts`;
              let data = {
                account: {
                  personId: person.id,
                  name: person.get('fullName') + ' Account',
                  splitPercentage: 100,
                  caregiverIds: mapBy(
                    filterBy(person.get('learner.contacts'), 'billPayer'),
                    'caregiverId',
                  ),
                  addressPersonId: person.id,
                },
              };
              let options = {
                data: JSON.stringify(data),
              };
              return this.fetch.post(url, options).then(() => {
                // Once the account has been created, re-query for all sibling accounts.
                return this.store.query('finance/account', {
                  personIds: JSON.stringify(personIds),
                });
              });
            }

            // Otherwise, we're all good - just return the results of the account query.
            return accounts;
          }),
      });
    });
  }

  afterModel() {
    let signatureMediaId = this.options.value(
      'finance:school:electronicSignature',
    );
    if (!isEmpty(signatureMediaId)) {
      return this.store.findRecord('media', signatureMediaId);
    }
  }
}
